<template>
  <div class="bbe-modal-info">
    <div class="bbe-modal-info__wrap">
      <i
        class="email-icon-close bbe-modal-info__close"
        @click="onClose"
      />
      <div
        class="bbe-modal-info__icon"
        :class="[color && `bbe-modal-info__icon_${color}`]"
        v-html="icon()"
      />
      <div class="bbe-modal-info__title">
        {{title}}
      </div>
      <div class="bbe-modal-info__description">
        {{description}}
      </div>
      <div
        v-if="description2"
        class="bbe-modal-info__description bbe-modal-info__description_second"
      >
        {{description2}}
      </div>
      <div
        class="bbe-modal-info__button bbe-button"
        @click="onClose"
      >
        {{buttonName}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BBEModalWindowInfo',
  props: {
    settings: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    title () {
      const { title } = this.settings
      return title
    },
    description () {
      const { description } = this.settings
      return description
    },
    description2 () {
      const { description2 } = this.settings
      return description2
    },
    buttonName () {
      const { buttonName = 'OK' } = this.settings
      return buttonName
    },
    icon () {
      const { icon } = this.settings
      return icon
    },
    color () {
      const { color = 'green' } = this.settings
      return color
    }
  },
  methods: {
    onClose () {
      this.$emit('onClose')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

  .bbe-modal-info {
    @include global-font;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: rgba($color-black, 0.56);
    z-index: 999;

    &__wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 450px;
      min-height: 263px;
      padding: 40px 18px 30px 18px;
      background: $color-white;
      border-radius: 8px;
      position: relative;
    }

    &__close {
      position: absolute;
      top: 18px;
      font-size: 11px;
      right: 18px;
      color: $color-silver-chalice;
      cursor: pointer;
      transition: 0.2s;

      &:hover {
        color: $color-gray;
      }
    }

    &__icon {
      display: flex;
      margin: 0 0 20px 0;

      &_green {
        color: $color-japanese-laurel;
      }

      &_red {
        color: $color-pomegranate
      }
    }

    &__title {
      font-size: 17px;
      line-height: 20px;
      font-weight: 500;
      margin: 0 0 8px 0;
    }

    &__description {
      padding: 0 20px 0 20px;
      font-size: 16px;
      line-height: 19px;
      font-weight: 400;
      text-align: center;

      &_second {
        margin: 5px 0 0 0;
      }
    }

    &__button {
      margin: 25px 0 0 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/ModalWindow/BBEModalWindowInfo.vue